import { clearStoredRoomAdmissionCredentials } from "./room-entry-storage";

const LOCAL_EVENT = "puzzle-muzzle:account-room-admission-ended";
const CHANNEL_NAME = "puzzle-muzzle:account-room-admission-lifecycle";
const TAB_ID = crypto.randomUUID();

export function endLocalAccountRoomAdmission(): void {
  clearStoredRoomAdmissionCredentials();
  try {
    window.dispatchEvent(new Event(LOCAL_EVENT));
  } catch {
    // A restricted browser can still clear credentials and close this caller's UI.
  }
  if (typeof BroadcastChannel === "undefined") return;
  try {
    const channel = new BroadcastChannel(CHANNEL_NAME);
    channel.postMessage({ kind: "ended", sourceTabId: TAB_ID });
    channel.close();
  } catch {
    // Cross-tab delivery is best effort; each tab still validates on reconnect.
  }
}

export function subscribeToLocalAccountRoomAdmissionEnd(
  listener: () => void,
): () => void {
  const receiveLocal = () => listener();
  let listeningLocally = false;
  try {
    window.addEventListener(LOCAL_EVENT, receiveLocal);
    listeningLocally = true;
  } catch {
    // Session validation still protects browsers without event support.
  }
  let channel: BroadcastChannel | undefined;
  try {
    channel = typeof BroadcastChannel === "undefined"
      ? undefined
      : new BroadcastChannel(CHANNEL_NAME);
  } catch {
    channel = undefined;
  }
  const receiveRemote = (event: MessageEvent<unknown>) => {
    if (!isRemoteEndMessage(event.data)) return;
    clearStoredRoomAdmissionCredentials();
    listener();
  };
  channel?.addEventListener("message", receiveRemote);
  return () => {
    if (listeningLocally) {
      window.removeEventListener(LOCAL_EVENT, receiveLocal);
    }
    channel?.removeEventListener("message", receiveRemote);
    channel?.close();
  };
}

function isRemoteEndMessage(value: unknown): boolean {
  if (typeof value !== "object" || value === null) return false;
  const message = value as Record<string, unknown>;
  return message.kind === "ended" &&
    typeof message.sourceTabId === "string" &&
    message.sourceTabId.length > 0 &&
    message.sourceTabId !== TAB_ID;
}
